import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'

import { BadgeComponent, LinkComponent, TypographyComponent } from '@hyperkit'

@Component({
  standalone: true,
  selector: 'shared-mitre-info',
  imports: [CommonModule, BadgeComponent, LinkComponent, TypographyComponent],
  templateUrl: './mitre-info.component.html',
  styleUrls: ['./mitre-info.component.scss'],
})
export class MitreInfoComponent {
  @Input() tactics: string[] = []
  @Input() techniques: string[] = []
  @Input() techniqueIds: string[] = []

  techniqueUrl(id: string): string {
    return `https://attack.mitre.org/techniques/${id.replace('.', '/')}`
  }
}
